export function contactName(relationship) {
  const person = relationship.contact || {}
  return relationship.preferred_name || [person.first_name, person.last_name].filter(Boolean).join(' ')
}

export function linkedinUrl(profile) {
  return /^https?:\/\//i.test(profile) ? profile : `https://${profile}`
}
